export default __webpack_public_path__ + "static/media/ea-girl.aa915c95.webp";